'use strict';

const getSignInUrl = ({ url, optionId }) => {
  const urlObj = new URL(url);
  urlObj.searchParams.append('wishlist_redirect', 'true');
  urlObj.searchParams.append('deal_option', optionId);
  return `/login?ref=${encodeURIComponent(urlObj.href)}`;
};

module.exports = {
  getSignInUrl,
};
